<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',

    }">
        <div class="popupContainer">
            <van-row class="header_container">

                <van-col span="21" class="header_col">
                    {{ t('common.promotion') }}
                </van-col>
                <van-col span="3" class="header_col">
                    <img src="@/assets/promotion/pramotionClose.png" alt="" @click="close" />
                </van-col>
            </van-row>
            <div class="card_list"></div>
            <div v-for="(item, index) in dataSet?.promotionList" :key="index">
                <PromotionCard v-if="isShowCard(item.name)" :itemData="item"
                    :un-claimed-count="activityCount(userStore.unreadActivityMsgList, item?.id)"
                    @openAgentPopup="openAgentPopup" @goToHome="close" @openPWA="openPWAPopup" />
            </div>
        </div>
    </van-popup>
</template>


<script setup lang="ts">
import { defineEmits, computed, PropType, defineProps } from 'vue'
import PromotionCard from './components/promotionCardNew.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { activityCount, PromotionData } from '@/view/promotion/supporrtScript';
const userStore = useUserStore()
const { t } = useI18n();

const props = defineProps({
    dataSet: {
        type: Object as PropType<PromotionData>,
        required: true
    }
})

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const emits = defineEmits(['open', 'close', "openAgentPopup", "openPWAPopup", 'update:show'])
const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}
const openAgentPopup = () => {
    emits("openAgentPopup")
}

const openPWAPopup = () => {
    emits("openPWAPopup")
}
const isShowCard = (name: string) => {
    if (name === 'pwa_reward') {
        const hasPwaInfo = userStore.PWAConvertData
        if (hasPwaInfo) {
            return true
        } else {
            return false
        }

    } else {
        return true
    }
}
</script>
<style scoped>
.van-popup {
    background-image: linear-gradient(180deg, rgba(136, 90, 41, 0.50) 0%, rgba(40, 18, 3, 0.50) 100%);
    backdrop-filter: blur(7px) !important;
    width: 100%;
    min-height: 90vh;
    padding-bottom: 100px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
}

.card_list {
    padding: 30px 25px;
}

.van-popup {
    background: transparent;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.header_container {
    height: 2.5rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #27190da3 !important;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    color: #ffffffd9;
    padding: 5px 12px;
    z-index: 1000;
}

.header_col img {
    opacity: 0.45;
    width: 30px;
}

.header_col {
    color: #ffffffa6;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
}
</style>